const e = typeof window < "u", n = e && window.screen.width <= 768;
export {
  e as HAS_WINDOW,
  n as isMobile
};
